module.exports = __webpack_public_path__ + "img/banner_img_3.67f96410.jpg";